import { render, staticRenderFns } from "./AnchorInput.vue?vue&type=template&id=24c7a39d&"
import script from "./AnchorInput.vue?vue&type=script&lang=js&"
export * from "./AnchorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports